import { BaseEntity } from '@base-entities';
import { UserTransformer } from '../transformer';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeUserTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new UserTransformer<E>();
}
